import React, { useEffect, useRef, useState } from "react";
import { CustomDateRange } from "src/app/components/CustomDateRange/CustomDateRange";

export function DatePickerFilter({ name, filters, updateFilter }) {
  const [waitEvent, setWaitEvent] = useState(null);

  const [value, setValue] = useState(filters[name]?.from);
  const [value2, setValue2] = useState(filters[name]?.to);

  const latest = useRef({ name, filters, updateFilter, value, value2 });
  latest.current = { name, filters, updateFilter, value, value2 };

  useEffect(() => {
    let timer = 0;
    const { value, value2, updateFilter, name } = latest.current;
    const delay = value === value2 ? 2500 : 500;

    if (waitEvent && updateFilter) {
      timer = setTimeout(() => {
        updateFilter(name, waitEvent.target.value);
      }, delay);
    }
    return () => clearTimeout(timer);
  }, [waitEvent]);

  useEffect(() => {
    const { filters, name } = latest.current;

    value !== undefined &&
      value2 !== undefined &&
      (value !== filters[name]?.from || value2 !== filters[name]?.to) &&
      setWaitEvent({
        target: {
          value:
            value === null
              ? { from: null, to: null }
              : { from: value, to: value2 },
        },
      });
  }, [value, value2]);

  return (
    <CustomDateRange
      dateFrom={value}
      setDateFrom={setValue}
      dateTo={value2}
      setDateTo={setValue2}
      toRight
    />
  );
}
